import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
type Theme = 'light' | 'dark';
interface ThemeValue {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggle: () => void;
}
const ThemeContext = createContext<ThemeValue | null>(null);
export function ThemeProvider({
  children,
  initial = 'light'
}: {
  children: React.ReactNode;
  initial?: Theme;
}) {
  const [theme, setTheme] = useState<Theme>(initial);
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', theme === 'dark');
    return () => root.classList.remove('dark');
  }, [theme]);
  const toggle = useCallback(() => setTheme(t => t === 'light' ? 'dark' : 'light'), []);
  const value = useMemo(() => ({
    theme,
    setTheme,
    toggle
  }), [theme, toggle]);
  return <ThemeContext.Provider value={value} data-id="element-1003" data-mp="2fe5xqcjgxght">{children}</ThemeContext.Provider>;
}
export function useTheme(): ThemeValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
}